module.exports = "/_next/static/images/solutionsImage-2c7473cec15f754f4d4145f02785ad56.jpg.webp";